// 返回 快訊列表
"use client";
import { useSelector, useDispatch } from "react-redux";
import { originURL, changePreviousUrl } from "@/slices/originURLSlice";

import { useRouter } from "next/navigation";

const FlashBack = () => {
  const dispatch = useDispatch();
  const { previousUrl } = useSelector(originURL); // 上一頁 url
  const router = useRouter();

  return (
    <div
      className="return cp"
      onClick={() => {
        if (previousUrl === "/flash") {
          dispatch(changePreviousUrl(""));
          router.back();
        } else router.push("/flash");
      }}
    >
      <span>返回列表</span>
    </div>
  );
};

export default FlashBack;
